const React = require('react');
const FavoriteListItem = require('./favorite.listitem.jsx').FavoriteListItem;
const FavoriteService = require('./services/favorite').FavoriteService;

const FavoritesListing = React.createClass({

    getInitialState: function() {
        return {
            showFull: true,
            term: '',
            results: []        };
    },

    handleChange: function(e) {
        this.setState({
            term: e.target.value
        });
    },

    toggleEdit: function(e) {
        if (this.props.onToggle)
            this.props.onToggle(e);
    },

    defaultResults: function() {
        this.setState({
            showFull: true
        });
    },

    submitForm: function(e) {
        e.preventDefault();

        if (!this.state.term || this.state.term.trim() === "") {
            this.defaultResults();
            return;
        }

        let _this = this;
        FavoriteService.searchFavorites(this.props.isMarket?this.props.account.UserID:null, this.state.term, function(err, favorites) {
            if (!err) {
                _this.setState({
                    results: favorites || [],
                    showFull: false
                });
            }
            else {
                _this.setState({
                    error: true,
                    results: [],
                    showFull: false
                })
            }
        });
    },

    render: function() {
        return (
            <div>
                <header className="layout-header">
                    <div className="header-inner-wrap curved">

                    <h1>{this.props.account.Name}</h1>
                    <form action="" onSubmit={this.submitForm} className="search">
                        <label htmlFor="search">Search: </label>
                        <input name="search" value={this.state.term} onChange={this.handleChange}/>
                    </form>
                        {this.props.isMarket?<span>&nbsp;</span> :
                            <a href="#" className="" onClick={this.toggleEdit}>add / remove
                            farms</a>}
                    </div>
                </header>
                {(this.state.showFull ? this.props.favorites : this.state.results ).map(result => (
                (result._source.AccountStatus === 2)?
                    <FavoriteListItem key={result._source.ID} favorite={result._source} />
                    :""
                ))}
                {(!this.state.showFull && this.state.results.length === 0)?<h2 className="no-results">No results found.</h2>:''}
            </div>
        );
    }
});

exports.FavoritesListing = FavoritesListing;
